module.exports = __webpack_public_path__ + "img/FruitNinjas.8fcd283c.jpg";